import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const loginApi = (username, password) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.LOGIN}`,
    { username, password },
    { headers: { "Content-Type": "application/json" } }
  );

export const signUpApi = (fullName, email, phoneNumber, password) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.SIGN_UP}`,
    { fullName, email, phoneNumber, password },
    { headers: { "Content-Type": "application/json", "Frontend-Origin": window.location.origin } }
  );

export const verifyEmailApi = (token) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.VERIFY_EMAIL}`, { token });

export const resendVerificationEmailApi = (email) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.RESEND_VERIFICATION_EMAIL}`, { email });

export const resetPasswordApi = (email, newPassword) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.RESET_PASSWORD}`, { email, newPassword });

export const verifyResetTokenApi = (token) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.VERIFY_TOKEN}`, { token });

export const markModalSeenApi = (userId) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.MARK_MODAL_SEEN}`, { userId });
